import { Formik, FormikProps } from 'formik'
import * as React from 'react'
import * as Yup from 'yup'
import { ISettingItem } from '../../types/global-settings'
import Loading from '../icons/membership/Loading'
import CheckCircle from '../icons/ui/CheckCircle'
import Close from '../icons/ui/Close'
import Important from '../icons/ui/Important'
import SettingForm from './SettingForm'

const validationSchema = Yup.object().shape({
  label: Yup.string().required('Name is required')
})

enum FormState {
  INIT = 'INIT',
  REQUESTING = 'REQUESTING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

interface IServiceProgramFormikState {
  formState: FormState
  errorClosed: boolean
  errorMessage: string
}

interface IServiceProgramFormikProps {
  title: string
  labelTitle: string
  children: React.ReactNode
  setting?: ISettingItem
  onSubmit?: (label: string) => Promise<void>
  onSuccess?: () => void
}

export default class SettingFormik extends React.Component<IServiceProgramFormikProps, IServiceProgramFormikState> {
  public formRef: any
  public state: IServiceProgramFormikState = {
    formState: FormState.INIT,
    errorClosed: true,
    errorMessage: ''
  }

  public render() {
    return (
      <>
        {!this.state.errorClosed && (
          <div className='pl2 pr2 pt1 pb1 bg-orange flex justify-between align-center'>
            <span className='font-white bold flex align-center'>
              <Important className='icon--small svg-fill-white mr1' />
              <span className='h5 font-white'>{this.state.errorMessage}</span>
            </span>
            <Close className='icon--small svg-fill-white' onClick={this.closeError} />
          </div>
        )}

        <div className='p2'>
          <div className='font-black h4'>{this.props.title}</div>
          <Formik
            ref={r => (this.formRef = r)}
            render={this.formRendrer}
            onSubmit={this.onSubmit}
            validationSchema={validationSchema}
            initialValues={{
              label: this.props.setting ? this.props.setting.label : ''
            }}
          />
        </div>
      </>
    )
  }

  private closeError = () => this.setState({ errorClosed: true })

  private formRendrer = (formikProps: FormikProps<any>) => (
    <SettingForm labelTitle={this.props.labelTitle} formikProps={formikProps}>
      <div className='right-align'>
        {this.state.formState === FormState.REQUESTING && (
          <>
            <span className='font-black bold h5'>Adding</span>
            <Loading className='col-1 ml1 animation-updating' />
          </>
        )}
        {this.state.formState === FormState.SUCCESS && (
          <>
            <span className='font-black bold h5'>Added</span>
            <CheckCircle className='svg-stroke-green ml1' />
          </>
        )}
        {![FormState.REQUESTING, FormState.SUCCESS].includes(this.state.formState) && this.props.children}
      </div>
    </SettingForm>
  )

  private onSubmit = (values: any) => {
    this.setState({
      formState: FormState.REQUESTING
    })

    if (this.props.onSubmit) {
      this.props
        .onSubmit(values.label)
        .then(() => this.handleSubmitSuccess())
        .catch(error => this.handleSubmitError(error))
    }
  }

  private handleSubmitError = (error: string) => {
    this.setState({
      formState: FormState.ERROR,
      errorClosed: false,
      errorMessage: error
    })
  }

  private handleSubmitSuccess = () => {
    this.setState({
      formState: FormState.SUCCESS
    })

    if (this.props.onSuccess) {
      this.props.onSuccess()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/SettingFormik.tsx